export default {
    namespaced: true,

    state: {
        list: [],
    },

    mutations: {
        SET(state, data) {
            if (data.length > 0) {
                const sortedDesc = data.sort(
                    (objA, objB) => Number(new Date(objB.created_at).getTime()) - Number(new Date(objA.created_at).getTime()),
                );
                state.list = sortedDesc;
            } else {
                state.list = data;
            }
        },
  },
}
